import React, { PureComponent } from "react";
import { Form, List, Modal, message, Button, Popconfirm, Input } from 'antd';
import _ from 'lodash'
import { store } from './../../store'
import {connect} from 'react-redux'
import { addProject, updateProject, removeProject } from './../../actions/projects'
import { updateProjectAction } from './../../actions/projectAction'
import firebase from 'firebase'
import nanoid from 'nanoid';

import { checkExistingProject } from '../project/util';
import config from './../../config'

const confirm = Modal.confirm;
const FormItem = Form.Item;

class CreateProjectForm extends React.Component {
  constructor(props){
    super(props);
    var selectedProject = (this.props.selectedProject) ? this.props.selectedProject: null;
    this.state = {
      selectedProject: (selectedProject) ? selectedProject: null,
      isUpdate: false
    }
  }

  componentDidMount() {
    var selectedProject = this.state.selectedProject;
    if(selectedProject) {
      setTimeout(() => {
        // Set existing project
        this.props.form.setFields({
          name: {
            value: selectedProject.name
          }
        });
        this.setState({ isUpdate: true })
      }, 0);
    }
  }

  checkDuplicate = (name) => {
    return new Promise((resolve, reject) => {
      var allNames = store.getState().projects.map(a => a.name);
      let found = allNames.filter(f => (f.toLowerCase() === name.toLowerCase()) ) 
      if(found.length > 0) resolve(true)
      else resolve(false)
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        var selectedProject = values;
        checkExistingProject(selectedProject.name).then(({ success, user}) => {
          if(success){
            // Implement Create/Update Project
            if(this.state.isUpdate === false){
              /* Create Empty Project */
              const projectID = nanoid()    
              var questionArr = []
  
              var projectRef = firebase
                                .database()
                                .ref(config.firebaseProjectsPath)
                                .child(projectID)
              
              var user = store.getState().user;
              var newData = {
                id: projectID,
                name: selectedProject.name,
                userId: (user.uid) ? user.uid: null,
                userEmail: (user.email) ? user.email: null,
                questions: questionArr,
                timestamp: firebase.database.ServerValue.TIMESTAMP
              };
              projectRef.set(newData).then((err) => {
                if(!err){
                  this.props.manageProjectForm(this.state.isUpdate, newData)
                }else message.error('Ops! There is something wrong when create ' + err)
              })
            } else {
              /* Update Project */
              const { name, id } = this.state.selectedProject;
              const projectID = id
              const projectName = values.name

              var projectNameRef = firebase
                                    .database()
                                    .ref(config.firebaseProjectsPath)
                                    .child(projectID);
  
              var updatedObj = Object.assign({}, { name: projectName }, _.omit(this.state.selectedProject, ['name']))
              projectNameRef
                .update({ name: projectName })
                .then((error) => {
                  if(!error){
                    this.props.manageProjectForm(this.state.isUpdate, updatedObj)
                  }else message.error('Ops! There is something wrong with update! ' + err)
                })            
            }
          }
        })
      } 
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { isUpdate } = this.state;
    
    return (
      <Form onSubmit={this.handleSubmit} className="create-project">
        <FormItem>
          <label>Name</label>
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Name your project!' }],
          })(
            <Input
              placeholder="Name Project" />
          )}
        </FormItem>
        <FormItem style={{ textAlign: 'right' }}>
          {
            (isUpdate === false) 
            && (
              <Button type="primary" htmlType="submit">
                Create
              </Button>
            )
          }
          {
            (isUpdate === true) 
            && (
              <Button type="primary" htmlType="submit">
                Update
              </Button>
            )
          }
          
        </FormItem>
      </Form>
    );
  }
}

const ProjectForm = Form.create()(CreateProjectForm);

class Projects extends PureComponent {
  constructor(props){
    super(props)
    var stateProject = store.getState();
    this.state = {
      isProjectLoading: true,
      data: (stateProject.projects !== null) ? stateProject.projects : [],
      projectEmpty: (stateProject.projects !== null) ? stateProject.projects : null,
      manageProjectVisible: false,
      selectedEditItem: null
    }
  }
  
  componentWillUpdate(nextProps) {
    let projectAction = store.getState().projectAction.action;
    if(projectAction === 'create'){
      this.setState({
        data: nextProps.projects
      })
    }

    // if (nextProps.projects !== this.props.projects) {
    //     // Do whatever you want
    // }
  }

  componentWillMount() {
    this.setState({ data: store.getState().projects })
    this.setState({isProjectLoading: false})
    // store.whenever('projects',(curState, prevState) => {
    //   let projectAction = store.getState().projectAction.action;
    //   console.log('Project action: ', projectAction)
    //   if(projectAction === 'create'){

    //     this.setState({
    //       data: [ curState, ...this.state.data]
    //     })
    //   }
    // })
  }

  onCompleteManageProject = (isUpdate, data) => {
    if(isUpdate === false){
      // Success new empty project
      store.dispatch(addProject(data))
      message.success('New project had been created')
    }else{
      // Success edit project
      store.dispatch(updateProject(data))
      message.success('Project had been updated')
    }
    this.setState({ manageProjectVisible: false, data: store.getState().projects })
  }

  onEdit(item) {
    this.setState({ manageProjectVisible: true, selectedEditItem : item})
  }

  onRemove(p) {
    var confirmPrompt = null;
    function confirmPromise() {
      return new Promise((resolve, reject) => {
        confirmPrompt = confirm({
          title: 'Remove this project `' + p.name +'`?',
          onOk(e) {
            // Remove from database
            var projectID = p.id;
            // alert('ok! ' + config.firebaseProjectsPath + projectID)
            firebase
              .database()
              .ref(config.firebaseProjectsPath + projectID)
              .remove((error) => {  
                if(!error) {
                  resolve(projectID);
                }else message.error('Ops! There is something wrong on remove.');

                return resolve(null);
              });
          },
          onCancel() { resolve(null) },
          okText: "Remove",
          cancelText: "Cancel",
          okType: "danger"
        })
      })
    }

    confirmPromise().then((removedId) => {
      if(removedId){
        store.dispatch(updateProjectAction({ action: 'removed' }))

        setTimeout(() => {
          var afterRemoved = this.state.data.filter((d) => { return d.id !== removedId });
          this.setState({ data: afterRemoved })

          var removedData = this.state.data.filter((d) => { return d.id === removedId });
          store.dispatch(removeProject(removedData))

          
          confirmPrompt.destroy()
        },0)
        
      }
    })
  }

  onProjectClick(item){
    this.props.handleExistingProjectSelected(item)
  }

  render() {
    const { isProjectLoading, data, projectEmpty, manageProjectVisible, newProjectName } = this.state;
    return (
      <div>
        <div style={{ paddingTop: '15px', paddingBottom: '15px'}}>
          <h3 style={{ color: 'black' }} >Your Projects</h3>
        </div>
        {
          (isProjectLoading) && (
            <div>Loading...</div>
          )
        }
        {
          (isProjectLoading === false) && (
            <div>
              <Button type="primary" onClick={(e) => { this.setState({manageProjectVisible: true })}}>
                Create
              </Button>

              {
                (projectEmpty !== null) &&
                (
                  <List
                    className="demo-loadmore-list"
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={item => (
                        <List.Item style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                          <List.Item.Meta
                            title={<a onClick={(e) => this.onProjectClick(item) }>{item.name}</a>}
                            description=""
                          />
          
                          <div>
                            <a onClick={(e) => this.onEdit(item) }>Edit</a>
                            <br/>
                            <a onClick={(e) => this.onRemove(item) }>Remove</a>
                          </div>
                          
                        </List.Item>
                    )}
                  />
                )
              }
              {
                (projectEmpty === null) &&
                (<div>Don't have any projects.</div>)
              
              }

              
              <Modal
                className="create-project-form"
                visible={manageProjectVisible}
                title={ (this.state.selectedEditItem) ? "Update Project" : "Create New Project" }
                onOk={(e) => this.onCreateConfirm}
                onCancel={(e) => { this.setState({manageProjectVisible: false, selectedEditItem: null }) } }
                destroyOnClose={true}
                footer={null}>
                <ProjectForm
                  selectedProject={this.state.selectedEditItem}
                  manageProjectForm={this.onCompleteManageProject.bind(this)}
                />
                
              </Modal>
            </div>
          )
        }
        
      </div>
    );
  }
}


const mapStateToProps = (state) => ({ 
  projects: state.projects,
});


export default connect(mapStateToProps)(Projects)


// WEBPACK FOOTER //
// ./src/components/project/index.js